import { render, staticRenderFns } from "./PricelistArticlesModal.vue?vue&type=template&id=46a3e96b&"
import script from "./PricelistArticlesModal.vue?vue&type=script&lang=js&"
export * from "./PricelistArticlesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports